<template>
  <el-form label-width="120px">
    <el-form-item
      label="Note"
      required
    >
      <el-input
        v-model="note.content"
        type="textarea"
      />
    </el-form-item>

    <el-form-item label="Attachments">
      <FileUpload
        drag
        multiple
      />
    </el-form-item>
  </el-form>
</template>

<script>
import FileUpload from '@/components/FileUpload'
import { TYPE_BROKEN } from '@/plugins/sdk/resources/Asset/Event'

export default {
  components: {
    FileUpload
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      event: Object.assign(new this.$sdk.asset_event(), {
        type: TYPE_BROKEN
      }),
      note: new this.$sdk.note()
    }
  },
  mounted () {
    this
      .event
      .notes
      .push(this.note)

    this
      .asset
      .events
      .push(this.event)
  }
}
</script>
